import React, { useEffect, useState } from 'react'

import { ArrowDown, ArrowUp, SearchIcon, SearchIconWhite } from "../../assets/images";

import { Accordion, Card, Form, Pagination, Table } from "react-bootstrap";

import { useDataAccessPagination } from '../../CustomHooks/useDataAccessPagination';
import EmergencyContactForm from './EmergencyContactForm'

const EmergencyContact = ({ selectedUsersList, setSelectedUsersList, isNotifFormEnabled, userList, setUserList, siteListString, selectedAllRegUsers, setSelectedAllRegUsers, isDarkTheme, emergencyContactList, setEmergencyContactList, categoryMaster, setCategoryMaster }) => {
    //region useState Start
    const [typingStart, setTypingStart] = useState(false);
    const [totalDevices, setTotalDevices] = useState(0);
    const [registerOpen, setRegisterOpen] = useState(false);
    const [categorySearch, setCategorySearch] = useState("")
    //region useState End

    const [nextClick, prevClick, pageCounter, currentPageNo, limit, totalPages, setCurrentPageNo, setTotalPages, maxPageAllowed, setPageCounter] = useDataAccessPagination(10, 1, 10, 1);

    //region useEffect Start





    useEffect(() => {
        if (categorySearch.length > 0) {
            setTypingStart(true);
        }
        if (categorySearch === "" && typingStart) {
            //Call the API Here.
            searchIconClicked(categorySearch)
        }
    }, [categorySearch])



    //region useEffect End


    const searchIconClicked = (e) => {
        let tempArr = categoryMaster.filter(x => x.Category.toLowerCase().includes(categorySearch.toLowerCase()))
        setEmergencyContactList(tempArr)
    }

    const PaginationComponent = (currentPageNo) => {
        let numbers = [];
        if (maxPageAllowed - 2 != 0 && (currentPageNo === maxPageAllowed || currentPageNo === (maxPageAllowed - 1) || currentPageNo === (maxPageAllowed - 2))) {
            numbers.push(
                <Pagination.Item
                    key={maxPageAllowed - 2}
                    active={maxPageAllowed - 2 == currentPageNo}
                    onClick={() => setCurrentPageNo(maxPageAllowed - 2)}
                >
                    {maxPageAllowed - 2}
                </Pagination.Item>)
            numbers.push(
                <Pagination.Item
                    key={maxPageAllowed - 1}
                    active={maxPageAllowed - 1 == currentPageNo}
                    onClick={() => setCurrentPageNo(maxPageAllowed - 1)}
                >
                    {maxPageAllowed - 1}
                </Pagination.Item>)
            numbers.push(
                <Pagination.Item
                    key={maxPageAllowed}
                    active={maxPageAllowed == currentPageNo}
                    onClick={() => setCurrentPageNo(maxPageAllowed)}
                >
                    {maxPageAllowed}
                </Pagination.Item>)
        }
        else if (maxPageAllowed - 1 != 0 && (currentPageNo === maxPageAllowed || currentPageNo === (maxPageAllowed - 1))) {
            numbers.push(
                <Pagination.Item
                    key={maxPageAllowed - 1}
                    active={maxPageAllowed - 1 == currentPageNo}
                    onClick={() => setCurrentPageNo(maxPageAllowed - 1)}
                >
                    {maxPageAllowed - 1}
                </Pagination.Item>)
            numbers.push(
                <Pagination.Item
                    key={maxPageAllowed}
                    active={maxPageAllowed == currentPageNo}
                    onClick={() => setCurrentPageNo(maxPageAllowed)}
                >
                    {maxPageAllowed}
                </Pagination.Item>)
        }
        else {
            for (let i = currentPageNo; i < currentPageNo + 3; i++) {
                if (i <= maxPageAllowed) {
                    numbers.push(
                        <Pagination.Item
                            key={i}
                            active={i == currentPageNo}
                            onClick={() => setCurrentPageNo(i)}
                        >
                            {i}
                        </Pagination.Item>
                    )
                }
            }
        }
        return numbers;
    }

    const uniqueKey = (data) => {
        return `${data.UserUniqueId}_${data.SiteId}`
    }

    const categoryHandler = (id) => {
        console.log("emergencyContactList", id)
        let arr = categoryMaster.map((item) => {
            let obj;
            if (item.Category == id) {
                obj = {
                    ...item,
                    "CategorySelected": !item.CategorySelected
                }
                console.log("item.CategorySelected", item.CategorySelected)
            } else {
                obj = {
                    ...item
                }
            }

            return obj
        })
        setCategoryMaster(arr)
        let tempArr = arr.filter(x => x.Category.toLowerCase().includes(categorySearch.toLowerCase()))
        console.log("searchIconClicked", tempArr)
        setEmergencyContactList(tempArr)
    }

    const allLevelHandler = (id, flag) => {
        let arr = categoryMaster.map((item) => {
            let obj;
            if (item.Category == id) {
                obj = {
                    ...item,
                    "ContactLevel": item.ContactLevel.map((d) => ({
                        "contactId": d.contactId,
                        "contactSelected": flag
                    }))
                }
            } else {
                obj = {
                    ...item
                }
            }

            return obj
        })
        setCategoryMaster(arr)
        let tempArr = arr.filter(x => x.Category.toLowerCase().includes(categorySearch.toLowerCase()))
        console.log("searchIconClicked", tempArr)
        setEmergencyContactList(tempArr)
    }

    const individualLevelHandler = (id, contactId) => {
        console.log("emergencyContactList", id)
        console.log("emergencyContactList", contactId)
        let arr = categoryMaster.map((item) => {
            let obj;
            if (item.Category == id) {
                obj = {
                    ...item,
                    "ContactLevel": item.ContactLevel.map((d) => {
                        let innerObj;
                        if (d.contactId == contactId) {
                            innerObj = {
                                "contactId": d.contactId,
                                "contactSelected": !d.contactSelected
                            }
                        } else {
                            innerObj = {
                                ...d
                            }
                        }
                        return innerObj
                    })
                }
            } else {
                obj = {
                    ...item
                }
            }

            return obj
        })
        setCategoryMaster(arr)
        let tempArr = arr.filter(x => x.Category.toLowerCase().includes(categorySearch.toLowerCase()))
        console.log("searchIconClicked", tempArr)
        setEmergencyContactList(tempArr)
    }

    return (
        <Accordion defaultActiveKey="0" style={{ marginTop: "20px" }}>
            <Card>
                <Accordion.Toggle
                    as={Card.Header}
                    eventKey="1" className='NotificationCardAccordion'
                    onClick={() => setRegisterOpen(!registerOpen)}
                >
                    Emergency Contact
                    {
                        !registerOpen ?
                            <img src={ArrowDown} alt="dropdown-arrow" /> :
                            <img src={ArrowUp} alt='up arrow' />
                    }
                </Accordion.Toggle>
                <Accordion.Collapse eventKey="1">
                    <Card.Body style={{ padding: "10px" }}>
                        <div className=" p-0">
                            <Table
                                className="table table-text-ext table-fixed report-table NotificationUserTable"
                                id="alert-activity-report"
                            >
                                <thead className="ReportTableHeader ReportTableHeadReport">
                                    <tr>
                                        <th style={{ width: "5%" }}>
                                            {/* <Form.Check aria-label="option 1" disabled={!isNotifFormEnabled} checked={selectedAllRegUsers} onChange={(e) => selectAllHandler(e)} /> */}
                                        </th>
                                        <th>
                                            <p>Category</p>
                                            <div className="SearchNotification">
                                                <input
                                                    className="SearchViewInput"
                                                    type="text"
                                                    placeholder="Search"
                                                    value={categorySearch}
                                                    onChange={(e) => setCategorySearch(e.target.value)}
                                                />
                                                {
                                                    isDarkTheme ?
                                                        <img
                                                            className="EyeIcon"
                                                            alt="Search-icon"
                                                            src={SearchIcon}
                                                            onClick={searchIconClicked}
                                                        /> :
                                                        <img
                                                            className="EyeIcon"
                                                            alt="Search-icon"
                                                            src={SearchIconWhite} height="15"
                                                            onClick={searchIconClicked}
                                                        />
                                                }
                                            </div>
                                        </th>
                                        <th>
                                            <p>Level</p>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        emergencyContactList && (
                                            emergencyContactList?.length > 0 ?
                                                emergencyContactList.map((item) => (
                                                    <EmergencyContactForm
                                                        key={item.Category}
                                                        item={item}
                                                        categoryHandler={categoryHandler}
                                                        individualLevelHandler={individualLevelHandler}
                                                        allLevelHandler={allLevelHandler}
                                                        isNotifFormEnabled={isNotifFormEnabled}
                                                    />
                                                )) :
                                                <div className='noRegisterFound'>
                                                    <p>No Record Found</p>
                                                </div>

                                        )
                                    }
                                    {
                                        !emergencyContactList && (
                                            <div className='noRegisterFound'>
                                                <p>No Record Available</p>
                                            </div>
                                        )
                                    }

                                </tbody>
                                {
                                    totalDevices == 0 || totalPages == 0 || totalPages <= limit
                                        ? null
                                        :
                                        <div className="PaginationDiv mb-2 mt-2">
                                            <h5 className="PageNumbers">
                                                {
                                                    totalDevices == 0 ? 0
                                                        : (currentPageNo - 1) * parseInt(limit) + parseInt(1)}
                                                -
                                                {
                                                    (currentPageNo * limit) > (totalDevices)
                                                        ? (totalDevices)
                                                        : currentPageNo * limit
                                                }
                                            </h5>
                                            <span>of</span>
                                            <h5 className='PageNumbers'>{totalDevices}</h5>

                                            <Pagination>
                                                <Pagination.Prev onClick={prevClick} disabled={currentPageNo == 1} />
                                                {
                                                    PaginationComponent(currentPageNo)
                                                }
                                                <Pagination.Next onClick={nextClick} disabled={currentPageNo == maxPageAllowed} />
                                            </Pagination>
                                        </div>
                                }
                            </Table>
                        </div>
                    </Card.Body>
                </Accordion.Collapse>
            </Card>
        </Accordion>
    )
}

export default EmergencyContact